import React from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";
import Background from "../components/background";
import Cypherdudes from "../components/cypherScripts/cypherdudes";
import CypherConsole from "../components/cypherScripts/cypherConsole";
import CypherMenu from "../components/cypherScripts/cypherMenu";
import { _bip39 } from "../components/bip39";
import { v4 as uuidv4 } from 'uuid';
import CypherDudesArtifact from '../web3/abi/CypherDudes.json';
import CypherDudesBitArtifact from '../web3/abi/CypherDudesBit.json';
import CypherDudesArchivesArtifact from '../web3/abi/CypherDudesArchives.json';
import { contractAddresses } from '../web3/contractsAddresses';
import { GiChart, GiExpand } from "react-icons/gi";
import { BsLightningFill, BsCloudDownload } from "react-icons/bs";
import MediaQuery from 'react-responsive';
import { breakpoints } from '../components/constants';
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";
import styled from 'styled-components';
import launchImg from '../components/img/launch240222.jpeg';
import os_Logo from '../components/img/OS_Logo.png';
import CYD_presentation from '../components/pdf/CYD_Booklet.pdf';

import { ethers } from "ethers";

import { bip39 } from "../App";


const InfoLink = styled(Link)`
&:focus, &:hover, &:visited, &:link, &:active {
    color:#fff;
}
&:hover{
    color:#00ff00;
}
`;

const TextLink = styled(Link)`
margin-bottom :10px;
&:focus, &:hover, &:visited, &:link, &:active {
    color:#fff;
}
&:hover{
    color:#00ff00;
}
`;

const DudeLink = styled(Link)`
font-size : 24px;
color : #00ff00;
&:focus, &:hover, &:visited, &:link, &:active {
    color:#00ff00;
}
&:hover{
    color:#fff;
}

@media (max-width: 768px) {
font-size : 20px;
}
`;

const utilities = require("../components/utilities");
const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

const About = () => {

    const mnemonicOptions = {
        method: 'GET',
        headers: {
            accept: 'application/json',
            'X-API-Key': process.env.REACT_APP_MNEMONIC_API_KEY
        }
    };

    const reMap = (n, inMin, inMax, outMin, outMax) => {
        return Math.round(((n - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin);
    }

    const navigate = useNavigate();

    const [sliderRange, setSliderRange] = useState(1337);
    const [inputValue, setInputValue] = useState(1337);
    const sliderRef = useRef(null);

    const [sliderRange2, setSliderRange2] = useState(0);
    const [inputValue2, setInputValue2] = useState(0);
    const sliderRef2 = useRef(null);

    const [dudeAction_, setDudeAction] = useState(0);
    const [layer1_, setLayer1] = useState(0);
    const [layer2_, setLayer2] = useState(0);
    const [layer3_, setLayer3] = useState(0);
    const [bitEnvironment_, setBitEnvironment] = useState(0);
    const [bitPalette_, setBitPalette] = useState(4);
    const [gridResolution_, setGridResolution] = useState(2);
    const [gridSize_, setGridSize] = useState(32);
    const [levelProgression_, setLevelProgression] = useState(0);
    const [lsb_, setLsb] = useState(1);
    const [ownerAddy_, setOwnerAddy] = useState('0x70997970c51862dc3a010c7d51b50e0d17dc79c8');
    const [secretWord_, setSecretWord] = useState('SATOSHI');
    const [tokenId_, setTokenId] = useState(1337);
    const [char, setChar] = useState(0);

    const [tokenURI, setTokenURI] = useState({});
    const [tokenName, setTokenName] = useState('');
    const [decodeTicker, setDecodeTicker] = useState(false);
    const [archiveData, setArchiveData] = useState({});
    const [ArchiveId, setArchiveId] = useState(1);

    const [dudeName, setDudeName] = useState('');
    const [dudeId, setDudeId] = useState(0);
    const [dudeURI, setDudeURI] = useState({});
    const [displayedDudeId, setDisplayedDudeId] = useState(0);
    const [owner, setOwner] = useState({});

    const { address, chainId, isConnected } = useWeb3ModalAccount();
    const { walletProvider } = useWeb3ModalProvider()
    const provider = new ethers.BrowserProvider(walletProvider);
    const openProvider = new ethers.BrowserProvider(window.ethereum);
    // Shared singleton providers — no per-render provider creation (src/web3/providers.js)
    const { infuraProvider } = require("../web3/providers");

    const cypherDudesReadContract = new ethers.Contract(
        contractAddresses.CypherDudes,
        CypherDudesArtifact.abi,
        infuraProvider
    );

    const cypherDudesBitReadContract = new ethers.Contract(
        contractAddresses.CypherDudesBit,
        CypherDudesBitArtifact.abi,
        infuraProvider
    );

    const cypherDudesArchivesReadContract = new ethers.Contract(
        contractAddresses.CypherDudesArchives,
        CypherDudesArchivesArtifact.abi,
        infuraProvider
    );

    useEffect(() => {
        document.getElementById('Dude_'.concat(dudeAction_)).className += " active_";
        document.getElementById('L1_'.concat(layer1_)).className += " active_";
        document.getElementById('L2_'.concat(layer2_)).className += " active_";
        document.getElementById('L3_'.concat(layer3_)).className += " active_";
        document.getElementById('bI_'.concat(bitEnvironment_)).className += " active_";
        document.getElementById('bP_'.concat(bitPalette_)).className += " active_";
        document.getElementById('Sz_'.concat(gridSize_)).className += " active_";
        document.getElementById('Rz_2').className += " active_";
        document.getElementById('encodeBtn').className += " active_";
        document.getElementById('inputAddress').value = ownerAddy_;
        document.getElementById('lsb_1').className += ' lsb';
        document.getElementById('ownershipBtn').click();
        document.getElementById('T0').click();
        document.getElementById('encrypt0').click();
        document.getElementById('privateArchBtn').click();
        var editors = document.getElementsByClassName("liveEditor");
        for (let i = 0; i < editors.length; i++) {
            editors[i].className = "liveEditor palette" + bitPalette_;
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            let randId = reMap(Math.random(), 0, 1, 0, 2047);
            setDudeId(randId);
            callDude(randId);
            _getTokenURI();
        }, 500);

    }, []);

    useEffect(() => {
        setTimeout(() => {
            _getTokenURI();
        }, 500);

    }, [ArchiveId]);

    useEffect(() => {
        if (decodeTicker) {
            decode();
        }
        setDecodeTicker(false)
    }, [decodeTicker])

    useEffect(() => {
        handleSliderInput();
    }, [sliderRef]);

    useEffect(() => {
        handleSliderInput2();
    }, [sliderRef2]);

    const traits = [
        { tab: "ddctn", name: "dude Action" },
        { tab: "l1", name: "layer 1" },
        { tab: "l2", name: "layer 2" },
        { tab: "l3", name: "layer 3" },
        { tab: "btEnv", name: "bit Environment" },
        { tab: "btPal", name: "bit Palette" }
    ]
    const dudeIndex = [
        { index: 0, name: "Backdoor Dude" },
        { index: 1, name: "Bitruvian Dude" },
        { index: 2, name: "Building Dude" },
        { index: 3, name: "Dude Scrolling" },
        { index: 4, name: "Fake Dude" },
        { index: 5, name: "Going To Zero Dude" },
        { index: 6, name: "Hashing Dude" },
        { index: 7, name: "Long Term Dude" },
        { index: 8, name: "Over Minting Dude" },
        { index: 9, name: "Mooning Dude" },
        { index: 10, name: "Pumping Dude" },
        { index: 11, name: "Rabbit Hole Dude" },
        { index: 12, name: "Dude Regulatoors" },
        { index: 13, name: "Eyes On The Chart" },
        { index: 14, name: "Rugged Dude" },
        { index: 15, name: "Scammed Dude" },
        { index: 16, name: "Dude Walking By" },
        { index: 17, name: "Transfer Dude" },
        { index: 18, name: "Follow The Dude" },
        { index: 19, name: "Secret Dude" },
    ]
    const layer1Index = [
        { index: 0, name: "Rare Pepes" },
        { index: 1, name: "Cryptopunks" },
        { index: 2, name: "Coins Flow" },
        { index: 3, name: "Chart" },
        { index: 4, name: "Moma Pixels" },
        { index: 5, name: "Pixelmon Reveal" },
        { index: 6, name: "Crypto Space" },
        { index: 7, name: "Crypto Voxel" },
        { index: 8, name: "Circuit Board" },
        { index: 9, name: "Uniswap" },
        { index: 10, name: "Mooncats" },
    ]
    const layer2Index = [
        { index: 0, name: "Gas Wars" },
        { index: 1, name: "PacMan" },
        { index: 2, name: "Hardware Wallet" },
        { index: 3, name: "Feels Good Man" },
        { index: 4, name: "Game Over" },
        { index: 5, name: "M3t4m4Sk" },
        { index: 6, name: "Promising collab" },
        { index: 7, name: "MaxPain" },
        { index: 8, name: "Green Chart" },
        { index: 9, name: "Press That Mint Button" },
        { index: 10, name: "Trash Art" },
        { index: 11, name: "none" },
    ]
    const layer3Index = [
        { index: 0, name: "Rare Pepes" },
        { index: 1, name: "Chart" },
        { index: 2, name: "Moma Pixels" },
        { index: 3, name: "Crypto Space" },
        { index: 4, name: "Crypto Voxel" },
        { index: 5, name: "Circuit Board" },
        { index: 6, name: "Uniswap" },
        { index: 7, name: "MaxPain" }
    ]
    const bitEnvironmentIndex = [
        { index: 0, name: "32 bits" },
        { index: 1, name: "32 bits animated" },
        { index: 2, name: "64 bits" },
        { index: 3, name: "64 bits animated" },
        { index: 4, name: "Who dis ?" },
        { index: 5, name: "Bitcoin Genesis Block" },
        //{ index: 6, name: "Data tunnel" },
        //{ index: 7, name: "Meta Script" },
        { index: 8, name: "The Cypherpunk" },
    ]
    const bitPaletteIndex = [
        { index: 0, name: "green, white, black" },
        { index: 1, name: "green, black, white" },
        { index: 2, name: "black, green, white" },
        { index: 3, name: "black, green, green" },
        { index: 4, name: "black, white, white" },
        { index: 5, name: "black, white, green" },
        { index: 6, name: "black, fuschia, aqua" },
        { index: 8, name: "blue, red, black" },
        { index: 9, name: "black, red, yellow" },
        { index: 10, name: "blue, yellow, fuschia" },
    ]
    const gridResolutionIndex = [
        { index: 2, name: "Low" },
        { index: 1, name: "Medium" },
        { index: 0, name: "High" }
    ]
    const gridSizeIndex = [
        { value: 32, name: "32" },
        { value: 64, name: "64" },
        { value: 128, name: "128" }
    ]
    const lsbIndex = [
        { value: 0, name: "01011000 01011000" },
        { value: 1, name: "01011000 01011001" }
    ]
    const features = [
        { tab: "feat1", feat: "WhitePaper" },
        { tab: "feat2", feat: "TokenInfo" },
        { tab: "feat3", feat: "Encryption" }
    ]

    document.addEventListener("mousemove", function (event) {
        if(document.getElementById("desktopMenu") != null){
            const nav = document.getElementById("navMenu");
            nav.style.transform = "translateY(0)";
            nav.style.transition = "transform 0.3s ease-in-out";
        }
    })

    const openTrait = (e, traitTab) => {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("traitTab");
        for (let i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("traitBtn");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active_", "");
        }
        document.getElementById(traitTab).style.display = "block";
        e.currentTarget.className += " active_";
    }
    const setActive = (e, className, trait, setTrait) => {
        var btns = document.getElementsByClassName(className);
        for (let i = 0; i < btns.length; i++) {
            btns[i].className = btns[i].className.replace(" active_", "");
        }
        e.currentTarget.className += " active_";
        setTrait(trait);
    }
    const setPalette = (e, className, trait, setTrait) => {
        setActive(e, className, trait, setTrait);
        var editors = document.getElementsByClassName("liveEditor");
        for (let i = 0; i < editors.length; i++) {
            editors[i].className = "liveEditor palette" + trait;
        }
    }

    const openGroup = (e, traitGroup) => {
        var groupContent, groupBtn;
        groupContent = document.getElementsByClassName("traitsGroup");
        for (let i = 0; i < groupContent.length; i++) {
            groupContent[i].style.display = "none";
        }
        groupBtn = document.getElementsByClassName("groupBtn");
        for (let i = 0; i < groupBtn.length; i++) {
            groupBtn[i].className = groupBtn[i].className.replace(" activeTab_", "");
        }
        document.getElementById(traitGroup).style.display = "flex";
        e.currentTarget.className += " activeTab_";
    }
    const checkAddressValidity = (manualInputAddress) => {
        if (manualInputAddress.length > 0) {
            if (manualInputAddress.match(/^0x[a-fA-F0-9]{40}$/)) {
                document.getElementById('inputAddress').style.boxShadow = '0 0 10px lime';
                document.getElementById('inputAddress').style.border = 'lime 1px solid';
            } else {
                document.getElementById('inputAddress').style.boxShadow = '0 0 10px red';
                document.getElementById('inputAddress').style.border = 'red 1px solid';
            }
        } else {
            document.getElementById('inputAddress').style.boxShadow = 'unset';
            document.getElementById('inputAddress').style.border = 'lime 1px solid';
        }
    }
    function handleSliderInput() {
        const range = 2047 - 0;
        const distance = sliderRef.current.value - 0;
        const percentage = (distance / range) * 100;
        setSliderRange(percentage);
        setInputValue(sliderRef.current.value);
        setTokenId(sliderRef.current.value);
    }
    function handleSliderInput2() {
        const range2 = 31 - 0;
        const distance2 = sliderRef2.current.value - 0;
        const percentage2 = (distance2 / range2) * 100;
        setSliderRange2(percentage2);
        setInputValue2(sliderRef2.current.value);
        setLevelProgression(32 - sliderRef2.current.value);
    }
    const maptoRange = (n, inMin, inMax, outMin, outMax) => {
        return ((n - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    }
    const shuffleWord = () => {
        var word = _bip39[Math.round(maptoRange(Math.random(), 0, 1, 0, 2047))];
        setSecretWord(word.toUpperCase());
    }
    const switchLsb = (e) => {
        var lsbBtn = document.getElementsByClassName("LsbBtn");
        for (let i = 0; i < lsbBtn.length; i++) {
            lsbBtn[i].className = lsbBtn[i].className.replace(" lsb", "");
        }
        e.currentTarget.className += " lsb"
    }
    const openFeat = (e, featTab) => {
        var groupContentb, encryptBtn;
        groupContentb = document.getElementsByClassName("encryptGroup");
        for (let i = 0; i < groupContentb.length; i++) {
            groupContentb[i].style.display = "none";
        }
        encryptBtn = document.getElementsByClassName("encryptBtn");
        for (let i = 0; i < encryptBtn.length; i++) {
            encryptBtn[i].className = encryptBtn[i].className.replace(" activeTab_", "");
        }
        document.getElementById(featTab).style.display = "flex";
        e.currentTarget.className += " activeTab_";
        switch (featTab) {
            case "feat1":
                document.getElementById("dO1_C").click()
                break;
            case "feat2":
                document.getElementById("dO1b_C").click()
                document.getElementById("dO2_C").click()
                break;
            case "feat3":
                document.getElementById("dO1b_C").click()
                document.getElementById("dO2c_C").click()
                break;
            default:
                document.getElementById("dO1_C").click()
                break;
        }
    }

    const opnTb = (e, tab) => {
        var encBtn = document.getElementsByClassName("Enc");
        for (let i = 0; i < encBtn.length; i++) {
            console.log(encBtn[i])
            encBtn[i].className = encBtn[i].className.replace(" active_", "");
        }
        e.currentTarget.className += " active_"
        document.getElementById(tab).click()
    }

    const preview = (e) => {
        setChar(e.currentTarget.value.length);
        document.getElementById('editorSandbox').innerHTML = e.currentTarget.value;
    }

    const openArchGroup = (e, archGroup) => {
        var archContent, archBtn;
        archContent = document.getElementsByClassName("archGroup");
        for (let i = 0; i < archContent.length; i++) {
            archContent[i].style.display = "none";
        }
        archBtn = document.getElementsByClassName("archBtn");
        for (let i = 0; i < archBtn.length; i++) {
            archBtn[i].className = archBtn[i].className.replace(" activeTab_", "");
        }
        document.getElementById(archGroup).style.display = "flex";
        e.currentTarget.className += " activeTab_";
        switch (archGroup) {
            case "private":
                setArchiveId(1)
                break;
            case "public":
                setArchiveId(0)
                break;
            default:
                break;
        }
    }

    const _getTokenURI = async () => {
        if (!isConnected) {
            setTokenURI({});
            try {
                setTokenURI({});
                try {
                    let tokenURI = await cypherDudesArchivesReadContract.tokenURI(ArchiveId);
                    let archive = await cypherDudesArchivesReadContract.archiveData(ArchiveId);
                    const tokenURIDecoded = utilities.parseBase64DataURI(tokenURI);
                    const tokenURIJSONDecoded = JSON.parse(tokenURIDecoded);
                    const animationURL = utilities.parseBase64DataURI(tokenURIJSONDecoded.animation_url);
                    const tokenEntry = {
                        tokenId: ArchiveId.toString(),
                        name: tokenURIJSONDecoded.name,
                        traits: tokenURIJSONDecoded.attributes,
                        animationURL: animationURL
                    }
                    setTokenURI(tokenEntry)
                    setTokenName(tokenURIJSONDecoded.name);
                    setArchiveData(archive);
                } catch (error) {
                    console.log(error)
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        } else {
            try {
                setTokenURI({});
                const signer = await provider.getSigner();
                const cypherDudesArchivesContract = new ethers.Contract(
                    contractAddresses.CypherDudesArchives,
                    CypherDudesArchivesArtifact.abi,
                    signer
                );
                try {
                    let tokenURI = await cypherDudesArchivesContract.tokenURI(ArchiveId);
                    let archive = await cypherDudesArchivesReadContract.archiveData(ArchiveId);
                    const tokenURIDecoded = utilities.parseBase64DataURI(tokenURI);
                    const tokenURIJSONDecoded = JSON.parse(tokenURIDecoded);
                    const animationURL = utilities.parseBase64DataURI(tokenURIJSONDecoded.animation_url);
                    const tokenEntry = {
                        tokenId: ArchiveId.toString(),
                        name: tokenURIJSONDecoded.name,
                        traits: tokenURIJSONDecoded.attributes,
                        animationURL: animationURL
                    }
                    setTokenURI(tokenEntry)
                    setTokenName(tokenURIJSONDecoded.name);
                    setArchiveData(archive);
                } catch (error) {
                    console.log(error)
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        }
    }
    function decode() {
        console.log('decode ready')
        if (archiveData.freeAccess) {
            let pass = archiveData.secret;
            console.log(pass);
            decrypt(pass)
        } else {
            var iframe = document.getElementById('tokenIframe');
            var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            var pass = iframeDocument.getElementById('dKey').value;
            decrypt(pass);
        }
    }
    const decrypt = async (key) => {
        try {
            var iframe = document.getElementById('tokenIframe');
            var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            var hash = iframeDocument.getElementById('decodedData').textContent;
            hash = hash.replace(/^\s+|\s+$/g, '');
            var bytes = ethers.hexlify(hash);
            const message = await cypherDudesReadContract.decrypt(key, hash);

            iframeDocument.getElementById('decodedData').innerHTML = message;
        } catch (error) {
            if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
                return;
            }
            console.log(error);
        }
    }

    window.addEventListener('decode', () => {
        setDecodeTicker(true)
    })

    const reloadScripts = () => {
        var container = document.getElementById('editorSandbox')
        let scriptList = container.getElementsByTagName('script');
        var newScripts = [];
        for (let i = 0; i < scriptList.length; i++) {
            let newScript = document.createElement('script');
            newScript.textContent = scriptList[i].textContent;
            scriptList[i].remove();
            newScripts.push(newScript);
        }
        newScripts.forEach((script) => document.getElementById('editorSandbox').lastChild.after(script))
    }

    // window.addEventListener("keydown", function (e) {
    //     if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
    //         e.preventDefault();
    //     }
    // }, false);

    const setSample = (e, type) => {
        var edtrBtn;
        edtrBtn = document.getElementsByClassName('editorBtn');
        for (let i = 0; i < edtrBtn.length; i++) {
            edtrBtn[i].className = edtrBtn[i].className.replace(" activeTab_", "");
        }
        e.currentTarget.className += " activeTab_";
        let sample;
        switch (type) {
            case "raw_text":
                sample = `This is an example of unformatted text.\nCarriage returns and tabs won't be interpreted.\nIt will just fill the width of the container with a left justification`
                break;
            case "html":
                sample = `<h1>STYLED HTML</h1>\n<p>such formatting is very useful to get <span style="color:red;text-decoration:underline;">propper</span> styling.</p>\n<p> Basically the full range of html tags in usable, such as :</p>\n<ul>\n<li>lists</li>\n<li>tables</li>\n<li><a href="https://www.felixfelixfelix.com" target="blank_">link (to my own website)</a></li>\n<li>and so on ...</li>\n</ul>\n<h3>Scripts</h3>\n<p>It is also possible to use the script tag. As it's injected in the context, it is necessary to activate the scripts by hitting the lightning button above.<br/>This button will trigger the default alert message saying "Hello World!"</p>\n<div style="width:100%; text-align:center;"><button onClick='setAlert("Hello World!")'>Click me</button></div>\n<p>Enjoy !</p>\n<script>\nfunction setAlert(text){alert(text)}\n</script>`
                break;
            case "svg":
                sample = `<svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"  xmlSpace="preserve"  version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/">
<g transform="translate(0.00630876,-0.00301984)">
<path fill="#f7931a" d="m63.033,39.744c-4.274,17.143-21.637,27.576-38.782,23.301-17.138-4.274-27.571-21.638-23.295-38.78,4.272-17.145,21.635-27.579,38.775-23.305,17.144,4.274,27.576,21.64,23.302,38.784z"/>
<path fill="#FFF" d="m46.103,27.444c0.637-4.258-2.605-6.547-7.038-8.074l1.438-5.768-3.511-0.875-1.4,5.616c-0.923-0.23-1.871-0.447-2.813-0.662l1.41-5.653-3.509-0.875-1.439,5.766c-0.764-0.174-1.514-0.346-2.242-0.527l0.004-0.018-4.842-1.209-0.934,3.75s2.605,0.597,2.55,0.634c1.422,0.355,1.679,1.296,1.636,2.042l-1.638,6.571c0.098,0.025,0.225,0.061,0.365,0.117-0.117-0.029-0.242-0.061-0.371-0.092l-2.296,9.205c-0.174,0.432-0.615,1.08-1.609,0.834,0.035,0.051-2.552-0.637-2.552-0.637l-1.743,4.019,4.569,1.139c0.85,0.213,1.683,0.436,2.503,0.646l-1.453,5.834,3.507,0.875,1.439-5.772c0.958,0.26,1.888,0.5,2.798,0.726l-1.434,5.745,3.511,0.875,1.453-5.823c5.987,1.133,10.489,0.676,12.384-4.739,1.527-4.36-0.076-6.875-3.226-8.515,2.294-0.529,4.022-2.038,4.483-5.155zm-8.022,11.249c-1.085,4.36-8.426,2.003-10.806,1.412l1.928-7.729c2.38,0.594,10.012,1.77,8.878,6.317zm1.086-11.312c-0.99,3.966-7.1,1.951-9.082,1.457l1.748-7.01c1.982,0.494,8.365,1.416,7.334,5.553z"/>
</g>
</svg>`
                break;
            case "img":
                sample = `<img src="data:image/gif;base64,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" style="image-rendering:pixelated;width:100%;">`
            default:
                break;
        }
        setChar(sample.length);
        document.getElementById('liveEditorInput').value = sample;
        document.getElementById('editorSandbox').innerHTML = sample;
    }

    const selectDudeByName = async () => {
        document.getElementById("inputDudeId").value = "";
        let smWord = dudeName.toLowerCase();

        if (_bip39.find(e => e === smWord) === smWord) {
            try {
                const docRef = bip39.doc(smWord);
                const docSnapshot = await docRef.get();
                if (docSnapshot.exists) {
                    const docData = docSnapshot.data();
                    callDude(docData.tokenId);
                    setDudeId(docData.tokenId);
                }
            } catch (error) {
                console.error();
            }
        } else {
            console.log('that word does not belong to the BIP 39')
        }
    };

    const selectDudeById = () => {
        document.getElementById("inputDudeName").value = "";
        callDude(dudeId);
    };

    const getValueByTraitType = (jsonData, traitType) => {
        const trait = jsonData.find(trait => trait.trait_type === traitType)?.value || '';
        return trait;
    }

    const getAddress = async (address) => {
        let resolvedAddress = await infuraProvider.lookupAddress(address);
        const holder = {
            longAddress: address,
            shortAddress: resolvedAddress === null ? address.slice(0, 6) + "..." + address.slice(-4) : resolvedAddress

        }
        return holder
    }

    const checkDude = () => {
        navigate(`/cypherdude/${displayedDudeId}`)
    }

    const callDude = async (id) => {
        setDisplayedDudeId(id);
        if (id < 1728) {
            try {
                setDudeURI({});
                try {
                    let tokenURI = await cypherDudesReadContract.tokenURI(id);
                    const tokenURIDecoded = utilities.parseBase64DataURI(tokenURI);
                    const tokenURIJSONDecoded = JSON.parse(tokenURIDecoded);
                    const animationURL = utilities.parseBase64DataURI(tokenURIJSONDecoded.animation_url);
                    let holderAddress = await cypherDudesReadContract.ownerOf(id);
                    setOwner(await getAddress(holderAddress));
                    const dudeEntry = {
                        id: uuidv4(),
                        tokenId: id.toString(),
                        name: tokenURIJSONDecoded.name,
                        gridSize: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Grid Size'),
                        gridResolution: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Grid Resolution'),
                        levelProgression: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Level Progression'),
                        action: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Action'),
                        layer1: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Layer 1'),
                        layer2: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Layer 2'),
                        layer3: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Layer 3'),
                        secretWord: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Secret Word'),
                        bitEnvironment: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Bit Environment'),
                        bitPalette: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Bit Palette'),
                        lsb: getValueByTraitType(tokenURIJSONDecoded.attributes, 'LSB'),
                        artefact: getValueByTraitType(tokenURIJSONDecoded.attributes,'artefacts'),
                        animationURL: animationURL
                    }
                    setDudeURI(dudeEntry);
                } catch (error) {
                    console.log(error)
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        } else {
            try {
                setDudeURI({});
                try {
                    let tokenURI = await cypherDudesBitReadContract.tokenURI(id);
                    const tokenURIDecoded = utilities.parseBase64DataURI(tokenURI);
                    const tokenURIJSONDecoded = JSON.parse(tokenURIDecoded);
                    const animationURL = utilities.parseBase64DataURI(tokenURIJSONDecoded.animation_url);
                    let holderAddress = await cypherDudesBitReadContract.ownerOf(id);
                    setOwner(await getAddress(holderAddress));
                    const dudeEntry = {
                        id: uuidv4(),
                        tokenId: id.toString(),
                        name: tokenURIJSONDecoded.name,
                        gridSize: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Grid Size'),
                        gridResolution: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Grid Resolution'),
                        levelProgression: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Level Progression'),
                        action: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Action'),
                        layer1: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Layer 1'),
                        layer2: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Layer 2'),
                        layer3: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Layer 3'),
                        secretWord: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Secret Word'),
                        bitEnvironment: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Bit Environment'),
                        bitPalette: getValueByTraitType(tokenURIJSONDecoded.attributes, 'Bit Palette'),
                        lsb: getValueByTraitType(tokenURIJSONDecoded.attributes, 'LSB'),
                        artefact: getValueByTraitType(tokenURIJSONDecoded.attributes,'artefacts'),
                        animationURL: animationURL
                    }
                    setDudeURI(dudeEntry);
                } catch (error) {
                    console.log(error)
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        }
    }


    return (
        <div>
            <Background />
            <div className="ProjectInfoContainer">
                <div className="projectInfo">
                    <p className="highlightInfo">THE CYPHERDUDES</p>
                    <p>Cypherdudes is a generative cryptoart series paying tribute to the Cypherpunk movement, which has been campaigning for the protection of privacy on the internet since the early 90s, and was behind the creation of bitcoin in 2008.</p>
                    <p>This series takes up the graphic universe of a character that I invented and gained some popularity in the crypto art scene : the cryptodude.A personification of crypto culture, the Cypherdude performs actions that visually translate the expressions and behaviors specific to this ecosystem</p>
                    <p>Each work in the series is unique and generated from an algorithm hosted directly on the blockchain. The parameters composing each work are selected from a wide range of elements created individually by myself and combined in a seeded random way. Each seed is determined by the blockchain on mint.</p>
                    <p className="highlightInfo">THE MESSAGE AND/ON THE WORK</p>
                    <p>Each owner of a work from the series has access to a hidden feature : the ability to inscribe an encrypted message in the work itself. The encryption key is decided by the owner on every inscription. This message can then only be decoded by a recipient knowing the key. This way, the work becomes a veritable tool at the service of its owner, who, by using it, makes it evolve visually using a simple steganographic technique.</p>
                    <p>The Cypherdudes thus becomes the visual witness to the presence of a message, and its digital security vault.</p>
                    <p className="highlightInfo">IMPORTANT INFORMATIONS</p>
                    <p>For each cypherdude, the owners will be able to claim one word as a name. This word will be picked among the BIP39 word list (the set of words used for seed phrases). This is a one shot action on a first come first served basis. Be ready for the hunt !</p>
                    <p><span className="highlightInfo">SUPPLY : 2048</span> (as many as BIP39 words)</p>
                    <br />
                    <p><span className="highlightInfo">LAUNCHED :</span> February 22 2024 at <InfoLink to="https://avant-galerie.com/cypherdudes"> Avant Galerie Vossen</InfoLink> in Paris</p>
                    <p><span className="highlightInfo">MINTED OUT :</span> September 14 2024</p>
                    <br />
                    <p id="search" className="highlightInfo">SEARCH A CYPHERDUDE</p>
                    <div className="Sandbox">
                        <div className="traitsDisplay">
                            <p className="highlightInfo">SEARCH BY NAME</p>
                            <p>type one word from the Bip39 to see which Cypherdude claimed it.</p>
                            <div className="adminTools">
                                <input id="inputDudeName" name="inputDudeName" placeholder="Type a word from the BIP39" className="inputId" type="text" onChange={e => setDudeName(e.target.value)} />
                                <button className="uxBtn" onClick={selectDudeByName}>SEARCH</button>
                            </div>
                            <p className="highlightInfo">SEARCH BY ID</p>
                            <p>type a number between 0 and 2047 to see the corresponding Cypherdude</p>
                            <div className="adminTools">
                                <input id="inputDudeId" name="inputDudeId" placeholder="Type one number" className="inputId" type="number" onChange={e => setDudeId(e.target.value)} />
                                <button className="uxBtn" onClick={selectDudeById}>SEARCH</button>
                            </div>
                            <br />
                            <div className="dudeInfo">
                                <MediaQuery maxWidth={parseInt(breakpoints.md)}>
                                    <div id="dudeSandBoxMobile">
                                        <iframe id="dudeDisplayIframe" sandbox="allow-scripts allow-same-origin" frameBorder="0" srcDoc={dudeURI.animationURL}></iframe>
                                    </div>
                                    <br />
                                </MediaQuery>
                                <DudeLink className="dudeLinkResp" onClick={checkDude}>{dudeURI.name}</DudeLink>
                                <div className='MyFolderTokenInfo'>
                                    <div className="dudeLinkChunk">
                                        <p>Owner : <TextLink target="_blank" to={`https://zapper.xyz/account/${owner.longAddress}`}>{owner.shortAddress}</TextLink></p>
                                        <a target='_blank' href={`https://opensea.io/assets/ethereum/${dudeId < 1728 ? contractAddresses.CypherDudes : contractAddresses.CypherDudesBit}/${dudeId}`}><img className='archiveLogoLink' src={os_Logo} alt="Logo" /></a>
                                    </div>
                                </div>
                                <p className='firstLine'>TRAITS :</p>
                                <div className='MyFolderTokenInfo'>
                                    <div className="dudeInfoChunk">
                                        <p>• Grid size : {dudeURI.gridSize}</p>
                                        <p>• Grid resolution : {dudeURI.gridResolution}</p>
                                        <p>• Level progression : {dudeURI.levelProgression} / 32</p>
                                        <p>• Action : {dudeURI.action}</p>
                                        <p>• Layer 1 : {dudeURI.layer1}</p>
                                        <p>• Layer 2 : {dudeURI.layer2}</p>
                                    </div>
                                    <div className="dudeInfoChunk">
                                        <p>• Layer 3 : {dudeURI.layer3}</p>
                                        <p>• Secret Word : {dudeURI.secretWord}</p>
                                        <p>• Bit Environment : {dudeURI.bitEnvironment}</p>
                                        <p>• Bit Palette : {dudeURI.bitPalette}</p>
                                        <p>• LSB : {dudeURI.lsb > 0 ? '01011000 01011000' : '01011000 01011001'}</p>
                                        <p>• Artefact : {dudeURI.artefact}</p>
                                    </div>
                                </div>
                                <br />
                                <br />
                            </div>
                        </div>
                        <MediaQuery minWidth={parseInt(breakpoints.md)}>
                            <div id="dudeSandBox">
                                <iframe id="dudeDisplayIframe" sandbox="allow-scripts allow-same-origin" frameBorder="0" srcDoc={dudeURI.animationURL}></iframe>
                            </div>
                        </MediaQuery>
                    </div>
                    <br />
                    <br />
                    <p className="highlightInfo">THE LAUNCH AT AVANT GALERIE VOSSEN</p>
                    <div className="fullWidth"> <img className='Img100' src={launchImg} alt="Launch Avant Gallery 022224" /></div>

                    <p className="highlightInfo">PRESENTATION</p>
                    <MediaQuery minWidth={parseInt(breakpoints.md)}>
                        <div className="fullWidthPdf">
                            <embed src={CYD_presentation} type="application/pdf" title="CypherDudes" width="100%" height="100%"></embed>
                        </div>
                    </MediaQuery>
                    <MediaQuery maxWidth={parseInt(breakpoints.md)}>
                        <p><Link target="_blank" to={CYD_presentation} className='chartBtn'> <BsCloudDownload /></Link> Download the pdf</p>
                    </MediaQuery>


                    <p className="highlightInfo">COMPOSITION</p>
                    <div className="Sandbox">
                        <div className="traitsDisplay">
                            <div className="traitsTypes">
                                <button className="uxBtn groupBtn" id="ownershipBtn" onClick={(event) => { openGroup(event, "ownership") }}>Ownership</button>
                                <button className="uxBtn groupBtn" onClick={(event) => { openGroup(event, "composition") }}>Composition</button>
                                <button className="uxBtn groupBtn" onClick={(event) => { openGroup(event, "encryption") }}>Encryption</button>
                            </div>
                            <div className="traitsMod">
                                <div className="traitsGroup" id="ownership">
                                    <div>
                                        <p>Owner's Address</p>
                                        <div className="inputTools">
                                            <input id="inputAddress" className="inputAddress" type="text" onChange={(e) => { checkAddressValidity(e.target.value) }} />
                                            <button className="uxBtn sm" onClick={() => { setOwnerAddy(document.getElementById('inputAddress')) }}>SUBMIT</button>
                                        </div>
                                    </div>
                                    <div>
                                        <p>Token Id</p>
                                        <div className="inputTools">
                                            <div className='range-slider'>
                                                <div className='slider-container'>
                                                    <input type="range" onInput={handleSliderInput} value={inputValue} min={0} max={2047} step={1} ref={sliderRef} className='slider' />
                                                    <div className='slider-thumb' style={{ left: `calc(${sliderRange}% - 0.5em)` }}></div>
                                                    <div className='progress' style={{ width: `${sliderRange}%` }}></div>
                                                </div>
                                                <button className='uxBtn sm'>{inputValue}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p>Secret Word (click to shuffle word from the BIP39 list)</p>
                                        <div className="inputTools">
                                            <button className="uxBtn fullWidthBtn" onClick={() => { shuffleWord() }}>{secretWord_}</button>
                                        </div>
                                    </div>
                                    <div>
                                        <p>LSB</p>
                                        <div className="inputTools">
                                            {lsbIndex.map((lsb, id) => {
                                                return <button id={`lsb_${id}`} key={`lsb_${id}`} onClick={(e) => { setLsb(lsb.index); switchLsb(e) }} className="uxBtn LsbBtn expandBtn">{lsb.name}
                                                </button>
                                            })}
                                        </div>
                                    </div>
                                </div>

                                <div className="traitsGroup" id="composition">
                                    <div className="compoTraits">
                                        <div className="traitsList">
                                            {traits.map((trait, id) => {
                                                return <button key={`T${id}`} id={`T${id}`} className="uxBtn traitBtn m" onClick={(event) => { openTrait(event, trait.tab) }}>{trait.name}</button>
                                            })}
                                        </div>
                                        <div className="traitContainer">
                                            <div className="traitTab" id="ddctn">
                                                {dudeIndex.map((dude, id) => {
                                                    return <div key={`A${id}`} className="radioSlct">
                                                        <button id={"Dude_".concat(dude.index)} onClick={(e) => setActive(e, "subTraitBtn A", dude.index, setDudeAction)} className="subTraitBtn A">{dude.name}</button>

                                                    </div>
                                                })}
                                            </div>
                                            <div className="traitTab" id="l1">
                                                {layer1Index.map((l1, id) => {
                                                    return <div key={`L1_${id}`} className="radioSlct">
                                                        <button id={"L1_".concat(l1.index)} onClick={(e) => setActive(e, "subTraitBtn L1", l1.index, setLayer1)} className="subTraitBtn L1">{l1.name}</button>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="traitTab" id="l2">
                                                {layer2Index.map((l2, id) => {
                                                    return <div key={`L2_${id}`} className="radioSlct">
                                                        <button id={"L2_".concat(l2.index)} onClick={(e) => setActive(e, "subTraitBtn L2", l2.index, setLayer2)} className="subTraitBtn L2">{l2.name}</button>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="traitTab" id="l3">
                                                {layer3Index.map((l3, id) => {
                                                    return <div key={`L3_${id}`} className="radioSlct">
                                                        <button id={"L3_".concat(l3.index)} onClick={(e) => setActive(e, "subTraitBtn L3", l3.index, setLayer3)} className="subTraitBtn L3">{l3.name}</button>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="traitTab" id="btEnv">
                                                {bitEnvironmentIndex.map((bI, id) => {
                                                    return <div key={`bI_${id}`} className="radioSlct">
                                                        <button id={"bI_".concat(bI.index)} onClick={(e) => setActive(e, "subTraitBtn bI", bI.index, setBitEnvironment)} className="subTraitBtn bI">{bI.name}</button>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="traitTab" id="btPal">
                                                {bitPaletteIndex.map((bP, id) => {
                                                    return <div key={`bP_${id}`} className="radioSlct">
                                                        <button id={"bP_".concat(bP.index)} onClick={(e) => setPalette(e, "subTraitBtn bP", bP.index, setBitPalette)} className="subTraitBtn bP">{bP.name}</button>
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="traitsGroup" id="encryption">
                                    <p>1. Grid Size</p>
                                    {gridSizeIndex.map((Sz, id) => {
                                        return <div key={`Sz_${id}`} className="radioSlct">
                                            <button id={"Sz_".concat(Sz.value)} onClick={(e) => setActive(e, "subTraitBtn Sz", Sz.value, setGridSize)} className="subTraitBtn Sz">{Sz.name}</button>
                                        </div>
                                    })}
                                    <p>2. Grid Resolution</p>
                                    {gridResolutionIndex.map((Rz, id) => {
                                        return <div key={`Rz_${id}`} className="radioSlct">
                                            <button id={"Rz_".concat(Rz.index)} onClick={(e) => setActive(e, "subTraitBtn Rz", Rz.index, setGridResolution)} className="subTraitBtn Rz">{Rz.name}</button>
                                        </div>
                                    })}
                                    <p>3. Level Progression</p>
                                    <div className='range-slider'>
                                        <div className='slider-container'>
                                            <input type="range" onInput={handleSliderInput2} value={inputValue2} min={0} max={31} step={1} ref={sliderRef2} className='slider' />
                                            <div className='slider-thumb' style={{ left: `calc(${sliderRange2}% - 0.5em)` }}></div>
                                            <div className='progress' style={{ width: `${sliderRange2}%` }}></div>
                                        </div>
                                        <button className='uxBtn sm'>{inputValue2}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="tokenSandBox"></div>
                        <Cypherdudes tokenId={tokenId_} secretWord={secretWord_} dudeAction={dudeAction_} layer1={layer1_} layer2={layer2_} layer3={layer3_} bitEnvironment={bitEnvironment_} bitPalette={bitPalette_} lsb={lsb_} gridSize={gridSize_} gridResolution={gridResolution_} levelProgression={levelProgression_} ownerAddy={ownerAddy_} message={'0x02797021a27e3f37a6631267647187c784f4a893cede9fd11089b7be3fefa5e972e0776cbe6bef2990c009a41138469675399bdba49c5e979e46aec7095cf428ccde43f6060c320d6680b73432f757d8660bbdd1e4144638fdb516b74fa77778ac8c65c42bed2d9176ed6cf973961bd1ba0d6b0bc548fdf583b645adb6f737e5c68abd277d3381484333309d3cc785091b92850f4c29f1f32dcd098d0adcdc70999a86c099b4b2a6a8333f764737ba6c0674375064b04ed8336e0f7bf6ab05a0'} />
                    </div>
                    <br />
                    <p className="highlightInfo">INTERACTION</p>
                    <div className="Sandbox">
                        <div className="traitsDisplay">
                            <p>the Cypherdude Console is the entry point to interact with all the token interface and trigger its features</p>
                            <br />
                            <p>GRID SIZE : 32, 64, 128 from left to right. This shows the base unit of the colored regular square grid</p>
                            <div className="consoleIcons">
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVQ4jWNkYGD4z4AfMOKTZCKgmSAYNWAwGIA3jqEAbzoZeC+MGkAFAwAxXgIecmo1uAAAAABJRU5ErkJggg=="></img>
                                </div>
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAL0lEQVQ4jWNkYGD4z4AKGNH4eOWZGCgEA28Aun8ZGEgMk4H3AlXCYDQdYIKRlg4ArA0IG+WyAAQAAAAASUVORK5CYII="></img>
                                </div>
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKklEQVQ4jWNgYGD4D8UwQBKfiYFCwIhmMrIYUXyKXQAzaTQMRsNgpIcBAJ3lL/GeFeu8AAAAAElFTkSuQmCC"></img>
                                </div>
                            </div>
                            <p>GRID RESOLUTION : Low, Medium, High from left to right. This shows the average colored square size inside the irregular grid</p>
                            <div className="consoleIcons">
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAH0lEQVQ4jWNgGGjAiMT+T45eJkpdMGrAqAGDw4CBBwC2SwEYE2ukzgAAAABJRU5ErkJggg=="></img>
                                </div>
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAUDDxiR2P9JUAsHTJS6YNSAwWDAwAMAmewBEMZQY3oAAAAASUVORK5CYII="></img>
                                </div>
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAWjYDAARiT2fzxyOAETpS4YeAMGHgAAha0BCIq/fecAAAAASUVORK5CYII="></img>
                                </div>
                            </div>
                            <p>MAIN MENU : Opens the encryption menu</p>
                            <div className="consoleIcons">
                                <div className="divIcon">
                                    <img className="consoleIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAZElEQVQ4jcWSQQoAMQgDzdL/fzk9bRFN67qXCj0U4jABzW4Pwp+NrAaQmQGsWII8kgqs58jSsGuQ9oYyiOOhESYBb4ikqlEDfFAtfTbwEAD/DCqTrUHsv4McDar+Zr1TPu1dnAmiZDUW/UZ26gAAAABJRU5ErkJggg=="></img>
                                </div>
                            </div>
                            <p>SWITCH : Play/pause the main animation</p>
                            <div className="consoleIcons">
                                <div className="divIcon">
                                    <img className="consoleIcon swIcon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAQAgMAAAAg3mRlAAAADFBMVEVHcEwAAABsbGwA/wDKljyQAAAAAXRSTlMAQObYZgAAAEtJREFUCNdjWIUMFjA0MKCABoZQhgBWBtZQIAiBc+X/A8FfIJeVISAUxm3Axg0IxctlJY0rC3JGbAOqMxpQHBnWAPMCE9hHDGg+AgAsBFS7sgd6DQAAAABJRU5ErkJggg=="></img>
                                </div>
                            </div>
                            <p>LXP : indicate the level progression</p>
                            <p>GXP : indicate the global progression</p>
                            <p>Available characters : indicate the current encoding capacity (see below for further explanations)</p>
                        </div>
                        <div id="consoleSandBox"></div>
                        <CypherConsole tokenId={tokenId_} secretWord={secretWord_} dudeAction={dudeAction_} layer1={layer1_} layer2={layer2_} layer3={layer3_} bitEnvironment={bitEnvironment_} bitPalette={bitPalette_} lsb={lsb_} gridSize={gridSize_} gridResolution={gridResolution_} levelProgression={levelProgression_} ownerAddy={ownerAddy_} message={'0x02797021a27e3f37a6631267647187c784f4a893cede9fd11089b7be3fefa5e972e0776cbe6bef2990c009a41138469675399bdba49c5e979e46aec7095cf428ccde43f6060c320d6680b73432f757d8660bbdd1e4144638fdb516b74fa77778ac8c65c42bed2d9176ed6cf973961bd1ba0d6b0bc548fdf583b645adb6f737e5c68abd277d3381484333309d3cc785091b92850f4c29f1f32dcd098d0adcdc70999a86c099b4b2a6a8333f764737ba6c0674375064b04ed8336e0f7bf6ab05a0'} />
                    </div>
                    <br />
                    <p className="highlightInfo">ENCRYPTION FEATURES</p>
                    <div className="Sandbox">
                        <div className="traitsDisplay">
                            <div className="traitsTypes">
                                <button id="encrypt0" className="uxBtn encryptBtn" onClick={(event) => { openFeat(event, "feat1") }}>whitepaper</button>
                                <button id="encrypt1" className="uxBtn encryptBtn" onClick={(event) => { openFeat(event, "feat2") }}>Token Info</button>
                                <button id="encrypt2" className="uxBtn encryptBtn" onClick={(event) => { openFeat(event, "feat3") }}>Encryption</button>
                            </div>
                            <div className="traitsMod">
                                <div className="encryptGroup" id="feat1">
                                    <div>
                                        <p>This text is the abstract of the project's whitepaper. It is displayed in the token description.</p>
                                        <p>Once released, it will be minted on chain, and available from this website.</p>
                                    </div>
                                </div>
                                <div className="encryptGroup" id="feat2">
                                    <div>
                                        <p>This section displays the traits of the token and gives access to three smart contract actions : LSB, PUBLIC ARCHIVE and PRIVATE ARCHIVE</p>
                                        <p>LSB : Based on the cryptography technique called Least Significant Bit, it switches the last bit of a 2 bytes sequences between 1 and 0. These bytes are the binary representation of two letters with two possibilities, XY and XX : the sex chromosoms. You can then switch back and forth from a masculine to a feminine silhouette anytime, and that's the Least Significant Bit of your personality.</p>
                                        <p>ARCHIVES : From the token interface, you can mint an archive of the last message that has been inscribed via the token. See Archive section for further informations.</p>
                                        <p>These three actions are only accessible by the token owner.</p>
                                    </div>
                                </div>
                                <div className="encryptGroup" id="feat3">
                                    <div>
                                        <p>The encryption app is the main feature of this project. You can encrypt any text data with a password of your choice and inscribe it on the blockchain to decipher it later by submitting the correct password.</p>
                                        <p>The main smart-contract contains three functions to handle this : encrypt, decrypt and incribe. These functions are only accessible to the owner of the token.</p>
                                        <p>The first two functions are designed as view functions (no blockchain state modification), so the password always remain private. The first one is hashing the message data against the password. The second one is deciphering the hash with the password.</p>
                                        <p>The last function is modifying the blockchain state as it is inscribing the hash on the blockchain using a storage contract.</p>
                                        <button onClick={(e) => { opnTb(e, 'dO2c_C') }} id="encodeBtn" className="subTraitBtn Enc">ENCODE</button>
                                        <p>In the "message" section, you can write any data in a text format. It can be raw text, html, svg, base64 images, anything. The character limit is defined by the token grid traits. The "secret key" is a password you choose to use as encryption key.</p>
                                        <button onClick={(e) => { opnTb(e, 'dO2b_C') }} className="subTraitBtn Enc">DECODE</button>
                                        <p>By entering the encryption key that correspond to the current encrypted data inside the token, its content is deciphered and revealed.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="menuSandbox"></div>
                        <CypherMenu tokenId={tokenId_} secretWord={secretWord_} dudeAction={dudeAction_} layer1={layer1_} layer2={layer2_} layer3={layer3_} bitEnvironment={bitEnvironment_} bitPalette={bitPalette_} lsb={lsb_} gridSize={gridSize_} gridResolution={gridResolution_} levelProgression={levelProgression_} ownerAddy={ownerAddy_} message={'0x02797021a27e3f37a6631267647187c784f4a893cede9fd11089b7be3fefa5e972e0776cbe6bef2990c009a41138469675399bdba49c5e979e46aec7095cf428ccde43f6060c320d6680b73432f757d8660bbdd1e4144638fdb516b74fa77778ac8c65c42bed2d9176ed6cf973961bd1ba0d6b0bc548fdf583b645adb6f737e5c68abd277d3381484333309d3cc785091b92850f4c29f1f32dcd098d0adcdc70999a86c099b4b2a6a8333f764737ba6c0674375064b04ed8336e0f7bf6ab05a0'} />
                    </div>
                    <br />
                    <p className="highlightInfo">THE CYPHERDUDES ARCHIVES</p>
                    <div className="Sandbox">
                        <div className="traitsDisplay">
                            <div className="traitsTypes">
                                <button className="uxBtn archBtn" id="privateArchBtn" onClick={(event) => { openArchGroup(event, "private") }}>Private Archives</button>
                                <button className="uxBtn archBtn" id="publicArchBtn" onClick={(event) => { openArchGroup(event, "public") }}>Public Archives</button>
                            </div>
                            <p>The Cypherdudes Archives is a child collection of the Cypherdudes project. <br />
                                Each Cypherdude token is a minter of archives. When you mint, the current encrypted message inside the cypherdudes is permanently wrapped around by an simple ERC721 token.<br />
                                It allows you to encrypt new message without losing track of the previous ones.<br />
                                You can turn the archive "on" and "off" by clicking on the top right switch</p>
                            <div className="traitsMod">
                                <div className="archGroup" id="private">
                                    <p>The Private Archives are keeping the encryption key unexposed to the blockchain.<br />
                                        It's content can be deciphered only by entering the correct key.<br />
                                        As in the cypherdudes encryption menu, the message is only deciphered in the front end, without being exposed to the public.<br />
                                        Private archives have a black background.</p>
                                </div>
                                <div className="archGroup" id="public">
                                    <p>The Public Archives are exposing the encryption key to the blockchain, allowing anyone to decipher and access its content.<br />
                                        On mint, you will be prompted to enter the encryption key corresponding to the currently encrypted data.<br />
                                        Important note : Make sure you use the <span style={{ textDecoration: "underlined" }}>EXACT SAME KEY</span> that you used to encrypt the data you want to archive. If a mistake is made, the content will never be accessible through the archive.<br />
                                        Private archives have a blue background.</p>
                                </div>
                            </div>
                        </div>
                        <div id="archiveSandBox">
                            <iframe id="tokenIframe" sandbox="allow-scripts allow-same-origin allow-popups" frameBorder="0" srcDoc={tokenURI.animationURL}></iframe>
                        </div>
                    </div>
                    <br />
                    <p id="editor" className="highlightInfo">MESSAGE LIVE EDITING</p>
                    <div className="Sandbox">
                        <div className="traitsDisplay">
                            <div className="liveEditorContainer">
                                <p>Type your message here to get an instant preview. If your data contains js scripts tag, hit the lightning </p>
                                <p>Start with one of the data formatting below</p>
                                <div className="traitsTypes">
                                    <button id="editor0" className="uxBtn editorBtn" onClick={(event) => { setSample(event, "raw_text") }}>RAW TEXT</button>
                                    <button id="editor1" className="uxBtn editorBtn" onClick={(event) => { setSample(event, "html") }}>HTML</button>
                                    <button id="editor2" className="uxBtn editorBtn" onClick={(event) => { setSample(event, "svg") }}>SVG</button>
                                    <button id="editor3" className="uxBtn editorBtn" onClick={(event) => { setSample(event, "img") }}>IMAGE</button>
                                    <button id="scriptTrigger" onClick={(e) => reloadScripts()} className='uxBtn'><BsLightningFill /></button>
                                </div>
                                <p>{char} / 12 000 characters</p>
                                <textarea id="liveEditorInput" className="liveEditor" onKeyUp={(e) => preview(e)} />
                            </div>
                        </div>
                        <div id="editorSandbox" className="liveEditor"></div>
                    </div>
                    <div className="projectInfo">
                        <p>for further informations :</p>
                        <p><InfoLink to="https://x.com/I____felix____I">FelixFelixFelix twitter Account</InfoLink></p>
                        <p><InfoLink to="https://x.com/CYPHERDUDES">CYPHERDUDES twitter Account</InfoLink></p>
                        <p>email contact : hello@felixfelixfelix.com</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;
